import { useForm } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { useCheckIsDuplicatedTitle, useCreatePlaylist, useUpdatePlaylist } from '@frontend-mono/main/playlist/data-access-playlist'
import { TitleInput } from '@frontend-mono/main/playlist/ui-title-input'
import { openModal } from '@frontend-mono/shared/modal/util-open-modal'
import { UpdatePlaylistInput } from '@frontend-mono/shared/data-access-graphql'

type UseCreateOrUpdatePlaylistModalParams = {
  playlist?: UpdatePlaylistInput
  onClose?: () => void;
}

export const useCreateOrUpdatePlaylistModal = (params?: UseCreateOrUpdatePlaylistModalParams) => {
  const { playlist, onClose } = params ?? {}
  const updateMode = !!playlist
  const { t } = useTranslation()
  const [createPlaylist] = useCreatePlaylist()
  const { updatePlaylist } = useUpdatePlaylist()
  const { checkIsDuplicated } = useCheckIsDuplicatedTitle()
  const { control, resetField, handleSubmit } = useForm<{ title: string }>({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })
  const onSubmit = async ({ title }: { title: string }) => {
    if (updateMode) {
      await updatePlaylist({
        playlist: {
          id: playlist.id,
          title,
          pinned: playlist.pinned,
        },
      })
      return
    }
    await createPlaylist({ variables: { input: { title, topicIds: [] } } })
  }

  return {
    openModal: () => {
      resetField('title')
      openModal({
        hasXButton: true,
        title: updateMode ? t('Playlist__edit_playlist_name') : t('Playlist__create_playlist'),
        content: ((closeModal) => (
          <TitleInput
            label="재생목록 이름"
            control={control}
            checkIsDuplicated={checkIsDuplicated}
            initialValue={updateMode ? playlist.title as string : undefined}
            onKeyPress={() => {
              handleSubmit(async (title) => {
                await onSubmit(title)
                closeModal()
              })()
            }}
          />
        )
        ),
        primaryButton: {
          onClick: (closeModal) => {
            handleSubmit(async (title) => {
              await onSubmit(title)
              closeModal()
            })()
          },
          text: updateMode ? '변경하기' : '만들기',
        },
        onCloseModal: onClose,
      })
    },
  }
}
